var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavouriteIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(-21.614 -141.614)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(21.614 141.614)",
    fill: "#0c6bfa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_heart",
    "data-name": "vuesax/linear/heart",
    transform: "translate(29.062 148.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heart",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.683,11.145a1.372,1.372,0,0,1-.78,0C4.078,10.522,0,7.923,0,3.518A3.508,3.508,0,0,1,3.5,0,3.471,3.471,0,0,1,6.293,1.41a3.491,3.491,0,0,1,6.293,2.108C12.586,7.923,8.508,10.522,6.683,11.145Z",
    transform: "translate(1.259 1.951)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H15.1V15.1H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteIcn);
export default __webpack_public_path__ + "static/media/favourite-icn.b9fd573e84684064dfbf4f3321d19662.svg";
export { ForwardRef as ReactComponent };